class MenuToggle {
  constructor(mobileNavDrill) {
    this.toggle = document.querySelector('[data-menu-toggle]');
    this.nav = document.querySelector('[data-site-nav]');
    this.mobileNavDrill = mobileNavDrill;
    this.mediaQuery = window.matchMedia('(max-width: 1199px)');
    if (!this.toggle || !this.nav) return;

    this.toggle.addEventListener('click', (event) => {
      event.stopPropagation();
      this.onToggle();
    });

    document.addEventListener('click', (event) => {
      if (!this.mediaQuery.matches) return;
      if (!this.nav.classList.contains('is-open')) return;
      if (this.nav.contains(event.target) || this.toggle.contains(event.target)) return;
      this.close();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.nav.classList.contains('is-open')) {
        this.close();
      }
    });
  }

  onToggle() {
    const isOpen = this.nav.classList.toggle('is-open');
    this.toggle.setAttribute('aria-expanded', String(isOpen));
    if (!isOpen) this.mobileNavDrill?.reset();
  }

  close() {
    this.nav.classList.remove('is-open');
    this.toggle.setAttribute('aria-expanded', 'false');
    this.mobileNavDrill?.reset();
    this.toggle.focus();
  }
}

class MobileNavDrill {
  constructor() {
    this.nav = document.querySelector('[data-site-nav]');
    if (!this.nav) return;

    this.header = this.nav.querySelector('[data-mobile-nav-header]');
    this.backBtn = this.nav.querySelector('[data-mobile-nav-back]');
    this.titleEl = this.nav.querySelector('[data-mobile-nav-title]');
    this.viewport = this.nav.querySelector('[data-mobile-nav-viewport]');
    this.megaMenu = this.nav.querySelector('[data-mega-menu]');
    this.mediaQuery = window.matchMedia('(max-width: 1199px)');
    this.stack = [];

    this.bind();
  }

  findMegaPanel(selector) {
    return this.megaMenu?.querySelector(selector) || null;
  }

  bind() {
    this.nav.addEventListener('click', (event) => {
      if (!this.mediaQuery.matches) return;

      const megaTrigger = event.target.closest('[data-mega-trigger]');
      if (megaTrigger) {
        event.preventDefault();
        event.stopPropagation();
        const parentsPanel = this.findMegaPanel('[data-mega-drill-panel="parents"]');
        const title = megaTrigger.querySelector('span')?.textContent?.trim() || 'All Categories';
        if (parentsPanel) this.drillDown(parentsPanel, title);
        return;
      }

      const megaParent = event.target.closest('[data-mega-parent]');
      if (megaParent) {
        event.preventDefault();
        event.stopPropagation();
        const parentId = megaParent.getAttribute('data-category-id');
        const title = megaParent.querySelector('.mega-menu__rail-label')?.textContent?.trim() || '';

        // Coming soon: skip empty children column, show message directly
        if (megaParent.getAttribute('data-under-construction') === 'true') {
          const branch = this.findMegaPanel(
            `[data-mega-branch][data-branch-id="${CSS.escape(String(parentId))}"]`
          );
          if (branch) this.drillDown(branch, title);
          return;
        }

        const childrenPanel = this.findMegaPanel(
          `[data-children-for="${CSS.escape(String(parentId))}"]`
        );
        if (childrenPanel) this.drillDown(childrenPanel, title);
        return;
      }

      const megaChild = event.target.closest('[data-mega-child]');
      if (megaChild) {
        event.preventDefault();
        event.stopPropagation();
        const categoryId = megaChild.getAttribute('data-category-id');
        const title = megaChild.querySelector('.mega-menu__rail-label')?.textContent?.trim() || '';
        const hasChildren = megaChild.getAttribute('data-has-children') === 'true';
        const isComingSoon = megaChild.getAttribute('data-under-construction') === 'true';

        if (!isComingSoon && hasChildren) {
          const grandPanel = this.findMegaPanel(
            `[data-grandchildren-for="${CSS.escape(String(categoryId))}"]`
          );
          if (grandPanel) {
            this.drillDown(grandPanel, title);
            return;
          }
        }

        const branch = this.findMegaPanel(
          `[data-mega-branch][data-branch-id="${CSS.escape(String(categoryId))}"]`
        );
        if (branch) this.drillDown(branch, title);
        return;
      }

      const megaGrandchild = event.target.closest('[data-mega-grandchild]');
      if (megaGrandchild) {
        event.preventDefault();
        event.stopPropagation();
        const categoryId = megaGrandchild.getAttribute('data-category-id');
        const title = megaGrandchild.querySelector('.mega-menu__rail-label')?.textContent?.trim() || '';
        const branch = this.findMegaPanel(
          `[data-mega-branch][data-branch-id="${CSS.escape(String(categoryId))}"]`
        );
        if (branch) this.drillDown(branch, title);
        return;
      }

      const trigger = event.target.closest('[data-nav-trigger]');
      if (!trigger || !this.nav.contains(trigger)) return;

      event.preventDefault();
      event.stopPropagation();

      const item = trigger.closest('[data-nav-item]');
      const submenu = item?.querySelector(':scope > [data-nav-submenu]');
      const title = trigger.querySelector('span')?.textContent?.trim() || '';

      if (submenu) this.drillDown(submenu, title);
    });

    this.backBtn?.addEventListener('click', () => this.drillUp());
  }

  getActivePanel() {
    return this.nav.querySelector('[data-nav-panel].is-active-panel') || this.nav.querySelector('[data-nav-panel]');
  }

  drillDown(submenu, title) {
    const currentPanel = this.getActivePanel();
    if (!currentPanel) return;

    const parentItem = submenu.parentElement;
    if (currentPanel.classList.contains('is-active-panel')) {
      currentPanel.classList.remove('is-active-panel');
    }
    currentPanel.classList.add('is-hidden');

    submenu.hidden = false;
    this.viewport.appendChild(submenu);
    submenu.classList.add('is-active-panel');
    this.stack.push({ panel: currentPanel, submenu, parentItem, title });

    this.nav.classList.add('is-drill-mode');
    if (this.header) this.header.hidden = false;
    if (this.titleEl) this.titleEl.textContent = title;
  }

  restoreDrilledPanel(panel) {
    if (panel.hasAttribute('data-mega-branch')) {
      panel.hidden = true;
    } else if (
      panel.hasAttribute('data-mega-drill-panel') &&
      (panel.getAttribute('data-mega-drill-panel') === 'children' ||
        panel.getAttribute('data-mega-drill-panel') === 'grandchildren') &&
      !panel.classList.contains('is-active')
    ) {
      panel.hidden = true;
    }
  }

  drillUp() {
    const entry = this.stack.pop();
    if (!entry) return;

    entry.submenu.classList.remove('is-active-panel');
    entry.parentItem?.appendChild(entry.submenu);
    this.restoreDrilledPanel(entry.submenu);
    entry.panel.classList.remove('is-hidden');

    if (this.stack.length > 0) {
      entry.panel.classList.add('is-active-panel');
      if (this.titleEl) this.titleEl.textContent = this.stack[this.stack.length - 1].title;
    } else {
      this.nav.classList.remove('is-drill-mode');
      if (this.header) this.header.hidden = true;
      if (this.titleEl) this.titleEl.textContent = '';
    }
  }

  reset() {
    while (this.stack.length) {
      const entry = this.stack.pop();
      entry.submenu.classList.remove('is-active-panel');
      entry.parentItem?.appendChild(entry.submenu);
      this.restoreDrilledPanel(entry.submenu);
      entry.panel.classList.remove('is-hidden');
    }

    this.nav.querySelectorAll('[data-mega-menu].is-open').forEach((megaMenu) => {
      megaMenu.classList.remove('is-open');
      megaMenu.querySelector('[data-mega-trigger]')?.setAttribute('aria-expanded', 'false');
      megaMenu.querySelector('[data-mega-panel]')?.setAttribute('hidden', '');
    });

    this.nav.classList.remove('is-drill-mode');
    if (this.header) this.header.hidden = true;
    if (this.titleEl) this.titleEl.textContent = '';
    this.stack = [];
  }
}

class NavDropdown {
  constructor() {
    this.items = Array.from(document.querySelectorAll('[data-nav-item].site-header__item--has-children'));
    if (!this.items.length) return;

    this.mediaQuery = window.matchMedia('(min-width: 1200px)');
    this.bind();
  }

  bind() {
    this.items.forEach((item) => {
      const trigger = item.querySelector(':scope > [data-nav-trigger]');
      if (!trigger) return;

      item.addEventListener('mouseenter', () => {
        if (!this.mediaQuery.matches) return;
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      });

      item.addEventListener('mouseleave', () => {
        if (!this.mediaQuery.matches) return;
        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.closeAll();
    });
  }

  closeAll() {
    this.items.forEach((item) => {
      item.classList.remove('is-open');
      item.querySelector(':scope > [data-nav-trigger]')?.setAttribute('aria-expanded', 'false');
    });
  }
}

class MegaMenu {
  constructor(root) {
    this.root = root;
    this.trigger = root.querySelector('[data-mega-trigger]');
    this.panel = root.querySelector('[data-mega-panel]');
    this.parents = Array.from(root.querySelectorAll('[data-mega-parent]'));
    this.childrenRail = root.querySelector('[data-mega-children-rail]');
    this.grandchildrenRail = root.querySelector('[data-mega-grandchildren-rail]');
    this.content = root.querySelector('[data-mega-content]');
    this.placeholder = root.querySelector('[data-mega-placeholder]');
    this.mobileQuery = window.matchMedia('(max-width: 1199px)');
    if (!this.trigger || !this.panel) return;

    this.defaultReady = false;
    this.bind();
  }

  bind() {
    this.trigger.addEventListener('click', (event) => {
      if (this.mobileQuery.matches) return;
      event.preventDefault();
      event.stopPropagation();
      this.toggle();
    });

    this.parents.forEach((parent) => {
      parent.addEventListener('click', () => {
        if (this.mobileQuery.matches) return;
        this.selectParent(parent);
      });
    });

    this.root.addEventListener('click', (event) => {
      if (this.mobileQuery.matches) return;

      const grandchild = event.target.closest('[data-mega-grandchild]');
      if (grandchild && this.root.contains(grandchild)) {
        event.preventDefault();
        this.selectGrandchild(grandchild);
        return;
      }

      const child = event.target.closest('[data-mega-child]');
      if (child && this.root.contains(child)) {
        event.preventDefault();
        this.selectChild(child);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close();
    });

    document.addEventListener('click', (event) => {
      if (!this.root.classList.contains('is-open')) return;
      if (!this.root.contains(event.target) && !this.panel.contains(event.target)) {
        this.close();
      }
    });
  }

  initDefault() {
    const firstParent = this.parents[0];
    if (firstParent) this.selectParent(firstParent);
  }

  hideGrandchildrenRail() {
    if (!this.grandchildrenRail) return;
    this.grandchildrenRail.hidden = true;
    this.root.classList.add('mega-menu--no-grandchildren');
    this.grandchildrenRail.querySelectorAll('[data-grandchildren-for]').forEach((panel) => {
      panel.classList.remove('is-active');
      panel.hidden = true;
      panel.querySelectorAll('[data-mega-grandchild]').forEach((el) => {
        el.classList.remove('is-active');
        el.removeAttribute('aria-current');
      });
    });
  }

  showGrandchildrenFor(categoryId) {
    if (!this.grandchildrenRail) return null;

    let activePanel = null;
    this.grandchildrenRail.querySelectorAll('[data-grandchildren-for]').forEach((panel) => {
      const active = panel.getAttribute('data-grandchildren-for') === String(categoryId);
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
      if (active) activePanel = panel;
    });

    if (activePanel) {
      this.grandchildrenRail.hidden = false;
      this.root.classList.remove('mega-menu--no-grandchildren');
    } else {
      this.hideGrandchildrenRail();
    }

    return activePanel;
  }

  selectParent(parentBtn) {
    const parentId = parentBtn.getAttribute('data-category-id');
    if (!parentId) return;

    this.parents.forEach((item) => {
      const active = item === parentBtn;
      item.classList.toggle('is-active', active);
      if (active) item.setAttribute('aria-current', 'true');
      else item.removeAttribute('aria-current');
    });

    const isComingSoon = parentBtn.getAttribute('data-under-construction') === 'true';
    this.root.classList.toggle('mega-menu--coming-soon-parent', isComingSoon);

    this.childrenRail?.querySelectorAll('[data-children-for]').forEach((panel) => {
      const active = panel.getAttribute('data-children-for') === String(parentId);
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });

    this.hideGrandchildrenRail();

    if (isComingSoon) {
      this.showBranch(parentId);
      return;
    }

    const activePanel = this.childrenRail?.querySelector(
      `[data-children-for="${CSS.escape(String(parentId))}"]`
    );
    const firstChild = activePanel?.querySelector('[data-mega-child]');
    if (firstChild) {
      this.selectChild(firstChild);
    } else {
      this.hideAllBranches();
      if (this.placeholder) this.placeholder.hidden = false;
    }
  }

  selectChild(childBtn) {
    const categoryId = childBtn.getAttribute('data-category-id');
    if (!categoryId) return;

    const panel = childBtn.closest('[data-children-for]');
    panel?.querySelectorAll('[data-mega-child]').forEach((el) => {
      const active = el === childBtn;
      el.classList.toggle('is-active', active);
      if (active) el.setAttribute('aria-current', 'true');
      else el.removeAttribute('aria-current');
    });

    const hasChildren = childBtn.getAttribute('data-has-children') === 'true';
    const isComingSoon = childBtn.getAttribute('data-under-construction') === 'true';

    if (isComingSoon || !hasChildren) {
      this.hideGrandchildrenRail();
      this.showBranch(categoryId);
      return;
    }

    const grandPanel = this.showGrandchildrenFor(categoryId);
    const firstGrandchild = grandPanel?.querySelector('[data-mega-grandchild]');
    if (firstGrandchild) {
      this.selectGrandchild(firstGrandchild);
    } else {
      this.hideGrandchildrenRail();
      this.showBranch(categoryId);
    }
  }

  selectGrandchild(grandchildBtn) {
    const categoryId = grandchildBtn.getAttribute('data-category-id');
    if (!categoryId) return;

    const panel = grandchildBtn.closest('[data-grandchildren-for]');
    panel?.querySelectorAll('[data-mega-grandchild]').forEach((el) => {
      const active = el === grandchildBtn;
      el.classList.toggle('is-active', active);
      if (active) el.setAttribute('aria-current', 'true');
      else el.removeAttribute('aria-current');
    });

    this.showBranch(categoryId);
  }

  hideAllBranches() {
    this.root.querySelectorAll('[data-mega-branch]').forEach((branch) => {
      branch.classList.remove('is-active');
      branch.hidden = true;
    });
  }

  showBranch(categoryId) {
    this.hideAllBranches();
    if (this.placeholder) this.placeholder.hidden = true;

    const branch = this.root.querySelector(
      `[data-mega-branch][data-branch-id="${CSS.escape(String(categoryId))}"]`
    );

    if (branch) {
      branch.hidden = false;
      branch.classList.add('is-active');
      if (this.content) this.content.scrollTop = 0;
    } else if (this.placeholder) {
      this.placeholder.hidden = false;
    }
  }

  ensureDefault() {
    if (this.defaultReady || this.mobileQuery.matches) return;
    this.initDefault();
    this.defaultReady = true;
  }

  open() {
    this.ensureDefault();
    this.root.classList.add('is-open');
    this.panel.hidden = false;
    this.trigger.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.root.classList.remove('is-open');
    this.panel.hidden = true;
    this.trigger.setAttribute('aria-expanded', 'false');
  }

  toggle() {
    if (this.root.classList.contains('is-open')) this.close();
    else this.open();
  }
}

class HeaderSearch {
  constructor(root) {
    this.root = root;
    this.form = root.querySelector('[data-search-form]');
    this.input = root.querySelector('[data-search-input]');
    this.typeInput = root.querySelector('[data-search-type]');
    this.results = root.querySelector('[data-search-results]');
    this.list = root.querySelector('[data-search-list]');
    this.empty = root.querySelector('[data-search-empty]');
    this.viewAll = root.querySelector('[data-search-view-all]');
    this.abortController = null;
    this.debounceTimer = null;
    this.minQueryLength = 2;
    this.searchType = 'collection,page';

    if (!this.form || !this.input || !this.results || !this.list || !this.viewAll || !this.typeInput) return;

    this.bind();
  }

  bind() {
    this.input.addEventListener('input', () => {
      window.clearTimeout(this.debounceTimer);
      this.debounceTimer = window.setTimeout(() => this.onInput(), 220);
    });

    this.input.addEventListener('focus', () => {
      if (this.list.children.length || this.empty.hidden === false) {
        this.showResults();
      }
    });

    this.form.addEventListener('submit', () => this.updateViewAllLink(this.input.value.trim()));

    document.addEventListener('click', (event) => {
      if (!this.root.contains(event.target)) this.hideResults();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.hideResults();
    });
  }

  onInput() {
    const query = this.input.value.trim();
    if (query.length < this.minQueryLength) {
      this.clearResults();
      this.hideResults();
      return;
    }
    this.fetchResults(query);
  }

  async fetchResults(query) {
    if (this.abortController) this.abortController.abort();
    this.abortController = new AbortController();

    const params = new URLSearchParams({
      q: query,
      'resources[type]': this.searchType,
      'resources[limit]': '8',
      'resources[limit_scope]': 'each',
      'resources[options][prefix]': 'last'
    });

    try {
      const response = await fetch(`${window.theme.routes.predictive_search_url}.json?${params.toString()}`, {
        signal: this.abortController.signal
      });

      if (!response.ok) throw new Error('Search request failed');

      const data = await response.json();
      this.renderResults(data?.resources?.results || {}, query);
    } catch (error) {
      if (error.name !== 'AbortError') {
        this.clearResults();
        this.hideResults();
      }
    }
  }

  renderResults(results, query) {
    const output = [];

    (results.collections || []).forEach((collection) => {
      output.push(this.buildResultItem(collection.url, collection.title, 'Collection'));
    });

    (results.pages || [])
      .filter((page) => String(page.url || '').includes('/pages/categories'))
      .forEach((page) => {
        output.push(this.buildResultItem(page.url, page.title, 'Category'));
      });

    this.list.innerHTML = output.join('');
    this.empty.hidden = output.length !== 0;
    this.updateViewAllLink(query);
    this.viewAll.hidden = query.length < this.minQueryLength;
    this.showResults();
  }

  updateViewAllLink(query) {
    if (!query) {
      this.viewAll.href = window.theme.routes.search_url;
      return;
    }

    const params = new URLSearchParams({ q: query });
    params.set('type', this.searchType);
    params.set('options[prefix]', 'last');
    this.viewAll.href = `${window.theme.routes.search_url}?${params.toString()}`;
  }

  buildResultItem(url, title, typeLabel) {
    return `
      <li>
        <a class="site-header__search-item" href="${url}">
          <span>${this.escapeHtml(title)}</span>
          <span class="site-header__search-type">${typeLabel}</span>
        </a>
      </li>
    `;
  }

  clearResults() {
    this.list.innerHTML = '';
    this.empty.hidden = true;
    this.viewAll.hidden = true;
  }

  showResults() {
    this.results.hidden = false;
  }

  hideResults() {
    this.results.hidden = true;
  }

  escapeHtml(text) {
    return String(text || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
}

class FullSearchPage {
  constructor(root) {
    this.root = root;
    this.list = root.querySelector('[data-full-search-list]');
    this.count = root.querySelector('[data-full-search-count]');
    this.empty = root.querySelector('[data-full-search-empty]');
    this.query = (root.getAttribute('data-query') || '').trim();
    this.type = (root.getAttribute('data-type') || 'collection,page').trim();

    if (!this.list || !this.count || !this.empty || !this.query) return;
    this.fetchAndRender();
  }

  async fetchAndRender() {
    const params = new URLSearchParams({
      q: this.query,
      'resources[type]': this.type,
      'resources[limit]': '50',
      'resources[limit_scope]': 'each',
      'resources[options][prefix]': 'last'
    });

    this.root.setAttribute('data-loading', 'true');

    try {
      const response = await fetch(`${window.theme.routes.predictive_search_url}.json?${params.toString()}`);
      if (!response.ok) throw new Error('Search request failed');

      const data = await response.json();
      const results = data?.resources?.results || {};
      const items = [];
      const includeCollections = this.type.includes('collection');
      const includePages = this.type.includes('page');

      if (includeCollections) {
        (results.collections || []).forEach((collection) => {
          items.push({
            url: collection.url,
            title: collection.title,
            label: 'Collection'
          });
        });
      }

      if (includePages) {
        (results.pages || [])
          .filter((page) => String(page.url || '').includes('/pages/categories'))
          .forEach((page) => {
            items.push({
              url: page.url,
              title: page.title,
              label: 'Category'
            });
          });
      }

      this.renderItems(items);
    } catch (error) {
      this.renderItems([]);
    } finally {
      this.root.setAttribute('data-loading', 'false');
    }
  }

  renderItems(items) {
    if (!items.length) {
      this.count.hidden = true;
      this.list.innerHTML = '';
      this.empty.hidden = false;
      return;
    }

    this.empty.hidden = true;
    this.count.hidden = false;
    this.count.textContent = `${items.length} results`;
    this.list.innerHTML = items
      .map(
        (item) => `
          <li class="search__result">
            <a href="${item.url}">${this.escapeHtml(item.title)}</a>
            <span class="search__type">${item.label}</span>
          </li>
        `
      )
      .join('');
  }

  escapeHtml(text) {
    return String(text || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const mobileNavDrill = new MobileNavDrill();
  new MenuToggle(mobileNavDrill);
  new NavDropdown();
  document.querySelectorAll('[data-mega-menu]').forEach((el) => new MegaMenu(el));
  document.querySelectorAll('[data-header-search]').forEach((el) => new HeaderSearch(el));

  const fullSearchRoots = document.querySelectorAll('[data-full-search]');
  if (!fullSearchRoots.length) return;
  fullSearchRoots.forEach((el) => new FullSearchPage(el));
});
